import dynamic from "next/dynamic";
import { useInView } from "react-cool-inview";
import FloatingMenu, {
  MenuBody,
} from "components/ui/FloatingMenu/FloatingMenu";
const CardRow = dynamic(() => import("components/card/CardRow"));
const LinkCard = dynamic(() => import("components/card/LinkCard"));

import { categories } from "lib/data/categories";
import styles from "./ExperienceHeaderMenu.module.scss";

export default function ExperienceHeaderMenu({ show }) {
  const { inView, observe } = useInView({
    onEnter: ({ unobserve }) => {
      unobserve();
    },
  });
  const categoryCards = categories.map((category, index) => {
    return (
      <LinkCard
        key={`${category.slug}-${index}`}
        title={category.category}
        slug={`/experiences${category.slug}`}
        image={category.image}
        divider={false}
        containerStyles={{ marginBottom: "var(--spacing-xs)" }}
      />
    );
  });

  return (
    <FloatingMenu
      show={show}
      styling={{
        top: "95%",
        right: "-616%",
      }}
    >
      <MenuBody style={{ width: "950px" }}>
        <div className={`${styles.container}`} ref={observe}>
          {/* <div className={`${styles.menuHeader}`}></div> */}
          <div className={`${styles.categoryCards}`}>
            {inView && (
              <CardRow
                cards={categoryCards}
                sectionTitle="Experience Categories"
                titleStyles={{
                  fontSize: "var(--font-size-md)",
                  color: "var(--dark-text)",
                }}
                sectionSlug="/experiences"
                sideScrollButtons={false}
                scrollIndicator={false}
              />
            )}
          </div>
        </div>
      </MenuBody>
    </FloatingMenu>
  );
}
